import { render, staticRenderFns } from "./Imagenes.vue?vue&type=template&id=296d59af&scoped=true&lang=pug&"
import script from "./Imagenes.vue?vue&type=script&lang=js&"
export * from "./Imagenes.vue?vue&type=script&lang=js&"
import style0 from "./Imagenes.vue?vue&type=style&index=0&id=296d59af&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d59af",
  null
  
)

export default component.exports